import { FC, ReactNode } from 'react';

import { ConfigProvider } from 'antd';

import useGetDefaultColorsMap from '@/hooks/useGetDefaultColorsMap';
import useIsMobile from '@/hooks/useIsMobile';

import { getAntdThemeConfig } from './ConfigProviderWrapper.constants';

interface IConfigProviderWrapperProps {
	children: ReactNode;
}

export const ConfigProviderWrapper: FC<IConfigProviderWrapperProps> = ({ children }) => {
	const colorsMap = useGetDefaultColorsMap();
	const isMobile = useIsMobile();
	const themeConfig = getAntdThemeConfig(colorsMap, isMobile);

	return <ConfigProvider {...themeConfig}>{children}</ConfigProvider>;
};
